import { Button, Divider, Grid } from "@mui/material";
import { t } from "i18next";
import { useState } from "react";

import type { EndPointSectionFieldsFragment } from "@/libs/generated/operations";

import { VehiclePhotos } from ".";
import { toPhotoVehicle } from "./types";

type PhotoModalProps = {
  delivery: EndPointSectionFieldsFragment;
  isAdmin: boolean;
  index: number;
};

function PhotoModal({ delivery, isAdmin, index }: PhotoModalProps) {
  const [open, setOpen] = useState(false);
  const vehicle = delivery.vehicles[index];

  if (!vehicle) {
    return null;
  }
  const photoVehicle = toPhotoVehicle(vehicle);
  return (
    <>
      <Button
        sx={{ my: 2 }}
        fullWidth
        variant="contained"
        color="primary"
        onClick={() => setOpen(true)}
      >
        {t("common.buttons.edit-photos")}
      </Button>

      <VehiclePhotos.Root open={open} onClose={() => setOpen(false)}>
        <Grid size={{ xs: 5 }}>
          <VehiclePhotos.Section
            type="before"
            vehicle={photoVehicle}
            images={photoVehicle.imagesBefore}
            isAdmin={isAdmin}
          />
        </Grid>

        <Grid size={{ xs: 2 }} sx={{ display: "flex", justifyContent: "center" }}>
          <Divider orientation="vertical" />
        </Grid>
        <Grid size={{ xs: 5 }}>
          <VehiclePhotos.Section
            type="after"
            vehicle={photoVehicle}
            images={photoVehicle.imagesAfter}
            isAdmin={isAdmin}
          />
        </Grid>
      </VehiclePhotos.Root>
    </>
  );
}

export default PhotoModal;
